import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import "./PhotoUpload.css";

const PhotoUpload = ({
  currentPhoto,
  onPhotoChange,
  onPhotoRemove,
  isLoading = false,
  error = "",
  isLogo = false,
  shouldContain = false,
}) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const maxFileSizeMB = 5;
  const ImageFormatToast = () => {
    return (
      <div className="profile-error-title-toast">
        Unsupported image format.<br />Please upload a valid image file.<br />
        <div className="profile-error-desc-toast">(e.g. JPEG, GIF, PNG, BMP, JPG, WebP, ICO)</div>
      </div>
    )
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/gif", "image/png", "image/bmp", "image/jpg", "image/webp", "image/x-icon"];
    if (!validTypes.includes(file.type)) {
      toast.error(ImageFormatToast());
      event.target.value = null;
      return;
    }
    const extention = file.name.split(".").pop();
    if (extention === "jfif") {
      toast.error(ImageFormatToast());
      event.target.value = null;
      return;
    }

    if (file.size > maxFileSizeMB * 1024 * 1024) {
      toast.error(`File size must be less than ${maxFileSizeMB}MB`);
      event.target.value = null;
      return;
    }

    setUploading(true);
    try {
      await onPhotoChange(file);
    } finally {
      setUploading(false);
      event.target.value = "";
    }
  };

  const handleRemovePhoto = async () => {
    try {
      await onPhotoRemove();
      toast.success("Photo removed successfully");
    } catch (error) {
      console.error("Error removing photo:", error);
      toast.error("Failed to remove photo");
    }
  };

  return (
    <div className="photo-upload-container">
      <div className="photo-preview-box">
        {currentPhoto ? (
          <img 
            src={currentPhoto}
            alt={isLogo ? "Logo" : "Profile Photo"} 
            className={isLogo && shouldContain ? "profile-company-logo" : "profile-photo"}
          />
        ) : (
          <div className="photo-placeholder-box">
            <div className="photo-placeholder-content">
              <span>{isLogo ? "Logo" : "Profile Photo"}</span>
            </div>
          </div>
        )}
      </div>
      
      <button
        type="button"
        className="upload-photo-link"
        onClick={() => fileInputRef.current?.click()}
        disabled={uploading || isLoading}
        id={isLogo ? "formCompanyLogo" : "formProfilePhoto"}
      >
        {uploading ? "Uploading..." : isLogo ? "Upload Company Logo" : "Upload your Photo"}
      </button>
      <div
        className="upload-photo-desc"
        id={isLogo ? "formCompanyLogoDesc" : "formProfilePhotoDesc"}
      >
        {isLogo ? "(169 X 23)" : "(150 X 150)"}
      </div>

      <input
        type="file"
        aria-label={isLogo ? "UploadCompanyLogo" : "UploadyourPhoto"}
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/jpeg, image/gif, image/bmp, image/jpg, image/png, image/webp, image/ico"
        onChange={handleFileChange}
        id={isLogo ? "formFileCompanyLogo" : "formFileProfilePhoto"}
      />

      {error && <div className="photo-upload-error">{error}</div>}
    </div>
  );
};

export default PhotoUpload;